import { Component, computed, input } from '@angular/core';
import { type AvatarSize } from './avatar.model';

@Component({
  selector: 'lib-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: [
    '../../tokens/colors.css',
    '../../tokens/avatar-tokens.css',
    './avatar.component.css',
  ],
  host: {
    '[class]': 'hostClasses()',
  },
})
export class AvatarComponent {
  /** Primary text (e.g. user name). */
  name = input.required<string>();

  /** Secondary text (e.g. role/position). */
  role = input<string>();

  /** Icon or emoji displayed inside the circle. Default: 👤 */
  icon = input<string>('👤');

  /** Size variant. */
  size = input<AvatarSize>('md');

  /** Background color of the circle. Accepts any CSS color value. */
  bgColor = input<string>();

  readonly hostClasses = computed(() => {
    const size = this.size();
    return {
      'msa-avatar': true,
      [`msa-avatar--${size}`]: true,
    };
  });
}
